<template>
  <b-container fluid class="top-padding bottom-padding no-horiz-padding">

        <b-container fluid class="top-padding bottom-padding no-horiz-padding">
            <img style="max-width: 100%" :src='this.getSiteImageUrl("iStock-000015582770-hw-site-updates-banner-caption-2.jpg")' />
        </b-container>

    <h2>June 6, 2020 Site Features Update</h2>
    <p>
        We are pleased to announce some new features for Handweaving.net, summarized below! These enable you to add information 
        to the site to help make drafts easier to find and use for all. 
    </p>
    <p>
        Over time, the use of all of these features will result in much more comprehensive, accurate, and 
        continually improving system for locating drafts according to the ways that people who use the site actually think about them!  
    </p>
    <hr>
    <h3>Draft Tags</h3>
    <p>
      Tags are descriptive words or short phrases that you can attach to any draft.  Later both you and 
      others can search by these to find the drafts.  Tags can reflect any way that you think about a draft, including visual attribtes, weave structure, and more.
    </p>
    <p>
        Examples:  twill, satin, stars, color and weave, hearts, etc.  
   </p>
    <p>   
        Tags and associated drafts can then be easily listed and <a href='/tag-cloud/alltags'>searched by anyone</a>.
    </p>
    <ul>
      <li>You must be signed in to add tags to drafts.</li>
      <li>
        To add a tag to a draft, choose Tags from any draft detail page, enter a tag name, and click Add Tag.
      </li>

      <li>
        To see all of your draft tags, choose Account -> My Draft Tags from the menu, clicking any tag to see the associated drafts.
      </li>

      <li>
        To see all draft tags on the site, choose Drafts -> Search For Drafts -> Search By Tag from the menu, clicking any tag to see the associated drafts.
      </li>
      <li>
        Your name may be shown later along with any draft tags you create (although the site does not do this now).
      </li>
    </ul>    
    <hr>
    <h3>Draft Boards</h3>
    <p>
        These are titled draft collections which you create and everyone can <a href='/board-search'>see and search</a>, similar to Pinterest.  Any draft on Handweaving.net can be added to your boards, which you can edit and everyone can see and use.  Links to boards can be easily shared with anyone.
    </p>
    <ul>
      <li>You must be signed in to create draft boards and to add drafts to them.</li>
      <li>
        To add a draft board, choose Account -> My Draft Boards from the menu, enter a title, and then click Add Board.
      </li>

      <li>
        To add drafts to a board, choose choose Actions -> Add to Board -> (Board Name) from any draft detail page.
      </li>

      <li>
        To see your draft boards later, choose Account -> My Draft Boards from the menu.
      </li>

      <li>
        To see draft boards created by others, choose Drafts -> Search For Drafts -> Searcy by Board from the menu.
      </li>

      <li>Your name is shown along with any draft boards you create.</li>
    </ul>

    <hr>
    <h3>Draft Likes</h3>
    <p>
        Draft detail pages have a Like button to quickly indicate drafts that you find interesting.  You can <a href='/collection-drafts/alllikes'>view all drafts that you and/or others like</a> and we may add this as a search filter later.
    </p>
    <ul>
      <li>You must be signed in to Like drafts.</li>
      <li>
        To Like any draft, simply click the Like button on the draft detail page.
      </li>
      <li>
        To remove a Like, simply click the Like button on the draft detail page a second time.
      </li>
 
      <li>
        To see all of the drafts you have Liked, choose Account -> My Liked Drafts from the menu.
      </li>

      <li>
        To see all of the drafts anyone has Liked, choose Drafts -> Search For Drafts -> Liked Drafts from the menu.
      </li>
      <li>
        Your name may be shown along with any draft likes you enter (although the site does not do this now).
      </li>
    </ul>  
    <hr>
    <h3>Draft Comments</h3>
    <p>
        Add your comments to any draft that everyone can see.  These can be weaving notes, clarifications, instructions, anything related to the draft that all would find useful.
    </p>
    <ul>
      <li>You must be signed in to add comments to drafts.</li>
      <li>
        To add a comment to a draft, choose Comments from any draft detail page, enter a comment, and click Add Comment.
      </li>

      <li>
        Your name and the date/time are shown along with any comments you enter.
      </li>

      <li>
        To see all of the comments for a draft, choose Comments from any draft detail page.
      </li>

      <li>
        To delete a comment you have made on a draft, choose Comments from any draft detail page and then click the (X) icon next to the comment.
      </li>
    </ul>
    <hr>
    <h3>Share Buttons</h3>
    <p>
        You can share links to all draft, search, and documents pages by clicking the Share button to get a link to email or post for others.
    </p>
    <hr>
    <h3>Search Box in Menu</h3>
    <p>
        The menu has a new search box on every page including the <a href='/'>Home Page</a>, for easy searching by draft IDs or keywords from anywhere within the site.
    </p>
    <hr>
    <h3>Expanded Searching</h3>
    <p>
        The <a href='#'>Drafts Landing Page</a> has many new search options enabled by all of these new features.
    </p>
    <hr>
    <h3>Interface Improvements</h3>
    <p>     
        The draft detail page has buttons at the top to hide and show various sections.  This makes room for all of the existing and new features and also creates cleaner pages when printed.  The enter key now works in forms and dialogs throughout the site.  On compatible browsers the scroll position is maintained for the back button for all pages.
    </p>
    <hr>
    <h3>Draft Categories Removed</h3>
    <p>
        The old draft categorizations system was incomplete and not useful; it is removed and will be superseded by tags.  
    </p>
    <hr>
    <h3>Other Remarks</h3>
    <p>     
        We may occasionally change or remove information added by site visitors such as tags and comments when needed to keep this accurate, focused, and as useful as possible to all.
    </p>
    <p>
        Once enough data is collected, this will enable many other interesting features to be added in the future.
    </p>
    <p>
        We hope that you will use and enjoy these latest features and welcome your comments and suggestions for improvements to these and for the site in general!
    </p>

    <helpUsButton/>
    <mailChimpSignup/>
  </b-container>

</template>

<script>
import mailChimpSignup from './MailChimpSignup.vue'
import helpUsButton from './HelpUsButton.vue'
import mediaService from '../mixins/mediaService.js'
export default {
    mixins: [mediaService],
    components: {
        helpUsButton: helpUsButton,
        mailChimpSignup: mailChimpSignup
    },
    created() {
        this.$store.commit('setPageTitle', 'Help')
    }
}
</script>

<style scoped>
.maxLogoHeight {
    max-height: 90px;
    height: 90px;
}
</style>



// WEBPACK FOOTER //
// src/components/Updates.vue